export const mockData = {
  company: {
    name: 'NanoGen',
    phone: '+90 (212) 555 0123',
    email: 'info@nanogen.com.tr',
    address: 'Organize Sanayi Bölgesi, 1. Cadde No:45, Gebze/Kocaeli, Türkiye'
  },
  catalogItems: [
    {
      id: 1,
      title: 'Mopa Konveyör Sistemi',
      description: 'Gıda sektörü için hijyenik ve dayanıklı konveyör sistemi',
      images: [
        '/images/machines/conveyor-1.jfif',
        '/images/machines/conveyor-3.jfif'
      ],
      category: 'Konveyör'
    },
    {
      id: 2,
      title: 'Paslanmaz Çelik Konveyör Bant Sistemi',
      description: 'Yüksek kapasiteli üretim hatları için esnek taşıma çözümü',
      images: [
        '/images/machines/conveyor-4.jfif',
        '/images/machines/conveyor-2.jfif'
      ],
      category: 'Konveyör'
    },
    {
      id: 7,
      title: 'Ürün Besleme Konveyör Sistemi',
      description: 'Üretim hatları için ürün besleme ve taşıma konveyör sistemi',
      images: [
        '/images/machines/urun-besleme-1.png',
        '/images/machines/urun-besleme-2.png'
      ],
      category: 'Konveyör'
    },
    {
      id: 8,
      title: 'Ambalaj Çıkış Konveyör Sistemi',
      description: 'Ambalajlama hattı çıkışı için toplama ve taşıma konveyör sistemi',
      images: [
        '/images/machines/ambalaj-cikis-konveyor.png'
      ],
      category: 'Konveyör'
    },
    {
      id: 9,
      title: 'Mamül Toplama Konveyör Sistemi',
      description: 'Üretim hattı sonunda mamül toplama ve taşıma konveyör sistemi',
      images: [
        '/images/machines/mamul-toplama-konveyor.png'
      ],
      category: 'Konveyör'
    },
    {
      id: 10,
      title: 'Paslanmaz Çelik Konveyör Bant Sistemi',
      description: 'Gıda sektörü için hijyenik paslanmaz çelik konveyör bant sistemi',
      images: [
        '/images/machines/paslanmaz-konveyor-3a.png',
        '/images/machines/paslanmaz-konveyor-3b.png'
      ],
      category: 'Konveyör'
    },
    {
      id: 11,
      title: 'Bisküvi Sıralama Konveyör Sistemi',
      description: 'Bisküvi üretim hatları için sıralama ve taşıma konveyör sistemi',
      images: [
        '/images/machines/biskuvi-siralama-1.png',
        '/images/machines/biskuvi-siralama-2.png',
        '/images/machines/biskuvi-siralama-3.png'
      ],
      category: 'Konveyör'
    },
    {
      id: 3,
      title: 'Helezon (Vida) Taşıma Sistemleri',
      description: 'Toz, granül ve parçacıklı malzemelerin taşınması için paslanmaz çelik helezon sistemleri',
      images: [
        '/images/machines/helical-1.png',
        '/images/machines/helical-2.jfif'
      ],
      category: 'Özel'
    },
    {
      id: 4,
      title: 'Kalıplı Hat Kalıp İçi Servolu Gofret Kesme Besleme',
      description: 'Hassas kesim ve yüksek üretim kapasitesi',
      images: [
        '/images/machines/wafer-cutting-1.jfif',
        '/images/machines/wafer-cutting-2.png'
      ],
      category: 'Gıda'
    },
    {
      id: 12,
      title: 'Kalıplı Hat Bisküvi Besleme Sistemi',
      description: 'Kalıplı üretim hatları için bisküvi besleme ve taşıma sistemi',
      images: [
        '/images/machines/kalipli-biskuvi-1.png',
        '/images/machines/kalipli-biskuvi-2.png'
      ],
      category: 'Gıda'
    },
    {
      id: 13,
      title: 'Hamur Depozitörü Sistemi',
      description: 'Hassas hamur dozajlama ve kalıplara dağıtma sistemi',
      images: [
        '/images/machines/hamur-depozitoru.png'
      ],
      category: 'Gıda'
    },
    {
      id: 14,
      title: 'Çikolata Servis Tank Sistemi',
      description: 'Çikolata depolama ve servis için paslanmaz çelik tank sistemi',
      images: [
        '/images/machines/cikolata-servis-tank.png'
      ],
      category: 'Gıda'
    },
    {
      id: 15,
      title: 'Elevatör Besleme Sistemi',
      description: 'Dikey taşıma ve besleme için elevatör sistemi',
      images: [
        '/images/machines/elevator-besleme.png'
      ],
      category: 'Gıda'
    },
    {
      id: 16,
      title: 'Yüksek Devir Tank Sistemi',
      description: 'Yüksek hızlı karıştırma ve işleme için paslanmaz çelik tank sistemi',
      images: [
        '/images/machines/yuksek-devir-tank.png'
      ],
      category: 'Gıda'
    },
    {
      id: 5,
      title: 'Yüksek Hassasiyetli CNC Freze ve Torna Parçaları',
      description: 'İmpeller, dişli, gövde ve hassas torna parçaları. Yüksek tolerans ve kalite standartlarında üretim.',
      images: ['/images/machines/cnc-parts-1.png'],
      category: 'CNC'
    },
    {
      id: 18,
      title: 'Yüksek Hassasiyetli CNC Freze ve Torna Parçaları',
      description: 'Yatak gövdeleri, hidrolik bloklar, vidalı miller ve bağlantı elemanları. Hassas CNC işleme.',
      images: ['/images/machines/cnc-parts-2.png'],
      category: 'CNC'
    },
    {
      id: 19,
      title: 'Yüksek Hassasiyetli CNC Freze ve Torna Parçaları',
      description: 'Flanş gövdeleri, bilyalı vidalı miller, hidrolik valfler ve endüstriyel bağlantı parçaları.',
      images: ['/images/machines/cnc-parts-3.png'],
      category: 'CNC'
    },
    {
      id: 20,
      title: 'Yüksek Hassasiyetli CNC Freze ve Torna Parçaları',
      description: 'Fren kompensatörleri, alıcı gövdeleri, özel kesici takımlar ve optik montaj aparatları.',
      images: ['/images/machines/cnc-parts-4.png'],
      category: 'CNC'
    },
    {
      id: 21,
      title: 'Yüksek Hassasiyetli CNC Freze ve Torna Parçaları',
      description: 'Rulman yuvası gövdeleri, çapraz bağlantı elemanları, kalıp tabanları ve vidalı mil sistemleri.',
      images: ['/images/machines/cnc-parts-5.png'],
      category: 'CNC'
    },
    {
      id: 23,
      title: 'Yüksek Hassasiyetli CNC Freze ve Torna Parçaları',
      description: 'Alüminyum kalıp plakaları, pirinç nozul sistemleri ve hassas işlenmiş montaj aparatları.',
      images: ['/images/machines/cnc-parts-6.jpg'],
      category: 'CNC'
    },
    {
      id: 17,
      title: 'Mamül Asansör Sistemleri',
      description: 'Üretim hatları için dikey mamül taşıma asansör sistemleri',
      images: ['/images/machines/mamul-asansor.png'],
      category: 'Özel'
    },
    {
      id: 22,
      title: 'Otomatik Şişe Dolum Hattı',
      description: 'Yüksek kapasiteli otomatik şişe dolum ve kapatma sistemi',
      images: ['/images/machines/sise-dolum-hatti.jpg'],
      category: 'Özel'
    },
    {
      id: 24,
      title: 'Titreşimli Besleme Sistemi',
      description: 'Parça yönlendirme ve sıralama için titreşimli besleyici sistemi',
      images: ['/images/machines/titresimli-besleme.jpg'],
      category: 'Özel'
    },
    {
      id: 6,
      title: 'Metal Kaynak Sistemi',
      description: 'Endüstriyel kaynak çözümleri',
      images: ['https://images.unsplash.com/photo-1745448797900-35d08e85e9db?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxtZXRhbHdvcmslMjBtYW51ZmFjdHVyaW5nfGVufDB8fHx8MTc2OTc3OTM5MHww&ixlib=rb-4.1.0&q=85'],
      category: 'Metal'
    }
  ],
  references: [
    { name: 'Ülker', logo: '/images/logos/ulker-logo.jpeg' },
    { name: 'Godiva', logo: '/images/logos/godiva-logo.png' },
    { name: 'Ülker Bisküvi', logo: '/images/logos/ulker-biskuvi-logo.png' },
    { name: 'Şölen', logo: '/images/logos/solen-logo.jfif' },
    { name: 'Efes Barlo', logo: '/images/logos/efes-barlo.jpg' },
    { name: 'Ülker', logo: '/images/logos/ulker-logo.jpeg' },
    { name: 'Godiva', logo: '/images/logos/godiva-logo.png' },
    { name: 'Ülker Bisküvi', logo: '/images/logos/ulker-biskuvi-logo.png' }
  ]
};
